import React from 'react';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';
import { useScrollData } from 'scroll-data-hook';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  hiddenSection: {
    visibility: 'hidden',
    height: 1,
    marginTop: -1,
  },
});

function ScrollTrigger({ onTrigger }) {
  const classes = useStyles();
  const { scrolling } = useScrollData();

  const handleVisibilityChange = isVisible => {
    if (isVisible && scrolling) {
      onTrigger();
    }
  };

  return (
    <VisibilitySensor onChange={handleVisibilityChange} scrollDelay={500}>
      <div className={classes.hiddenSection}>This is hidden</div>
    </VisibilitySensor>
  );
}

ScrollTrigger.propTypes = {
  onTrigger: PropTypes.func,
};

export default ScrollTrigger;
